import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import { TextFieldProps } from "@mui/material/TextField/TextField";
import { Box } from "@mui/material";

import { CustomFormProps } from "../../types/components/Form";

const AppTextFieldNoForm = styled((props: TextFieldProps & CustomFormProps) => {
  return (
    <Box sx={{ marginBottom: "10px", width: "100%" }}>
      <TextField
        {...props}
        fullWidth
        variant="outlined"
        InputProps={{
          style: { padding: "0px 15px" }, // Add padding here
        }}
      />
    </Box>
  );
})(({ theme }) => ({
  "& .MuiInputBase-root": {
    border: "1px solid white",
    borderRadius: "30px",
  },
  "& .Mui-focused fieldset": {
    border: "1px solid #ffffff",
  },
  "& .MuiInputBase-input": {
    color: "white",
  },
  "& .Mui-disabled .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.grey[200],
  },
}));

export default AppTextFieldNoForm;
